import axios from "axios";
import {
  createAllCell,
  changeColWidth,
  changeRowHeight,
  createContentAndMerge,
} from "../components/excel_download_common";
import { GetCookie, check_vat } from "./common";
import { decodeToken } from "./auth";

// 엑셀 다운로드
export async function excelDown(type, ids, cp_price) {
  try {
    const ExcelJS = require("exceljs");
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();
    // 데이터 가져오기
    const dataObj = await getStatementList(type, ids);
    const totalCnt = dataObj.data.lists.length;
    const offset = 23;
    const page = Math.ceil(totalCnt / offset);
    let startRow = 1;
    for (let i = 0; i < page; i++) {
      // 데이터 리스트 배열 자르기
      const startCnt = i * offset;
      const lastCnt =
        startCnt + offset > totalCnt ? totalCnt : startCnt + offset;
      const pageData = { ...dataObj.data };
      pageData.lists = pageData.lists.slice(startCnt, lastCnt);
      // 엑셀 상단(구매자 정보)
      await createEstimateExcelHeader(worksheet, dataObj.username, startRow);
      // 엑셀 중반 (구매 상품 정보)
      await createEstimateExcelTable(
        worksheet,
        type,
        pageData,
        startCnt,
        startRow
      );
      // 엑셀 하단(결제 정보)
      await createEstimateExcelFooter(
        worksheet,
        type,
        pageData,
        startRow + 32,
        "A".charCodeAt(0),
        cp_price
      ); // 총합
      startRow += 40;
      // worksheet.mergeCells("C9:D9");
    }
    // 엑셀 다운로드
    await downloadExcel(workbook);
  } catch (e) {
    console.log(e);
  }
}

// 엑셀 상단 (구매자 정보)
export async function createEstimateExcelHeader(
  worksheet,
  username,
  type,
  data,
  startRow = 1,
  startCol = "A".charCodeAt(0)
) {
  // 엑셀 제목
  worksheet.getCell(String.fromCharCode(startCol) + startRow).value = "견적서";
  worksheet.mergeCells(
    String.fromCharCode(startCol) +
      startRow +
      ":" +
      String.fromCharCode(startCol + 6) +
      startRow
  );
  worksheet.getCell(String.fromCharCode(startCol) + startRow).alignment = {
    horizontal: "center",
    vertical: "middle",
  };
  worksheet.getCell(String.fromCharCode(startCol) + startRow).font = {
    name: "Arial Black",
    size: 16,
    bold: true,
  };

  // 공급자 정보 변수
  const contentsArr = [
    // 공급자
    //사업자 번호 D3
    ["사업자번호", String.fromCharCode(startCol + 3) + (startRow + 2)],
    //상호 D4
    ["상호", String.fromCharCode(startCol + 3) + (startRow + 3)],
    //사업장 소재지 D5
    ["사업장소재지", String.fromCharCode(startCol + 3) + (startRow + 4)],
    // 업태 D6
    ["업태", String.fromCharCode(startCol + 3) + (startRow + 5)],
    // 전화번호 D7
    ["전화번호", String.fromCharCode(startCol + 3) + (startRow + 6)],
    //557-81-00960 E3
    ["557-81-00960", String.fromCharCode(startCol + 4) + (startRow + 2)],
    //파츠고 E4
    ["파츠고", String.fromCharCode(startCol + 4) + (startRow + 3)],
    //서울특별시 강남구 D5
    [
      "서울특별시 강남구 테헤란로82길 15 디아이타워 5층",
      String.fromCharCode(startCol + 4) + (startRow + 4),
    ],
    //도매 E6
    ["도매", String.fromCharCode(startCol + 4) + (startRow + 5)],
    //070-4742-4989 E7
    ["070-4742-4989", String.fromCharCode(startCol + 4) + (startRow + 6)],
    //대표자명 F4
    ["대표자명", String.fromCharCode(startCol + 5) + (startRow + 3)],
    //종목 F6
    ["종목", String.fromCharCode(startCol + 5) + (startRow + 5)],
    //이종철 G4
    ["이종철", String.fromCharCode(startCol + 6) + (startRow + 3)],
    //전자부품 G6
    ["전자부품", String.fromCharCode(startCol + 6) + (startRow + 5)],
  ];

  // 구매자 정보 변수
  const infoArr = [
    [new Date(), String.fromCharCode(startCol) + (startRow + 2)],
    [username + " 귀하", String.fromCharCode(startCol) + (startRow + 3)],
    ["주문번호 : N/A", String.fromCharCode(startCol) + (startRow + 4)],
  ];

  // 공급자 및 구매자 셀 병합 변수
  const mergeContentsArr = [
    // COL A ROW 1
    //현재날짜 A3
    String.fromCharCode(startCol) +
      (startRow + 2) +
      ":" +
      String.fromCharCode(startCol + 1) +
      (startRow + 2),
    //구매자 성함 A4
    String.fromCharCode(startCol) +
      (startRow + 3) +
      ":" +
      String.fromCharCode(startCol + 1) +
      (startRow + 3),
    //주문번호 A5
    String.fromCharCode(startCol) +
      (startRow + 4) +
      ":" +
      String.fromCharCode(startCol + 1) +
      (startRow + 4),
    //557-81-00960 E3 체크
    String.fromCharCode(startCol + 4) +
      (startRow + 2) +
      ":" +
      String.fromCharCode(startCol + 6) +
      (startRow + 2),
    //서울특별시 강남구 E5
    String.fromCharCode(startCol + 4) +
      (startRow + 4) +
      ":" +
      String.fromCharCode(startCol + 6) +
      (startRow + 4),
    // 070-4742-4989 E7
    String.fromCharCode(startCol + 4) +
      (startRow + 6) +
      ":" +
      String.fromCharCode(startCol + 6) +
      (startRow + 6),
  ];

  // 공급자 및 주문자 정보 셀 병합 함수
  createContentAndMerge(
    worksheet,
    contentsArr,
    mergeContentsArr,
    null,
    infoArr
  );

  // 공급자 정보 (사업장 소재지 예외)
  worksheet.getCell(String.fromCharCode(startCol + 5) + (startRow + 4)).font = {
    size: 7,
  };
}

// 엑셀 중반 (구매 상품 정보)
export async function createEstimateExcelTable(
  worksheet,
  type,
  data,
  startCnt,
  startRow = 1,
  startCol = "A".charCodeAt(0)
) {
  // 장바구니 상품 데이터
  let rawData = makeExcelRawData(
    type,
    type === "cart" ? data.lists : data.items,
    startCnt
  );

  // 각 행 지정 (전체)
  const columnArr = ["A", "B", "C", "D", "E", "F", "G"];

  // 행 넓이값 추가 (전체)
  const columnWidth = [
    ["A", "3.5"],
    ["B", "17.7"],
    ["E", "9"],
    ["C", "15.7"],
    ["F", "8.55"],
    ["G", "11.55"],
  ];

  // 열 높이값 추가 (전체)
  const rowHeight = [
    [startRow, "20"],
    [startRow + 1, "5"],
    [startRow + 2, "15"],
    [startRow + 3, "15"],
    [startRow + 4, "15"],
    [startRow + 5, "15"],
    [startRow + 6, "15"],
    [startRow + 8, "15"],
    [startRow + 31, "3"],
  ];

  // 행 넓이값 및 열 높이값 적용
  columnWidth.map((content) => {
    changeColWidth(worksheet, content[0], content[1]);
  });
  rowHeight.map((content) => {
    changeRowHeight(worksheet, content[0], content[1]);
  });

  // 엑셀 상품 테이블 추가
  worksheet.addTable({
    name: "MyTable",
    ref: String.fromCharCode(startCol) + (startRow + 8),
    style: {
      theme: "TableStyleMedium2",
    },

    columns: [
      { name: "순번" },
      { name: "품목" },
      { name: "브랜드" },
      { name: " " },
      { name: "수량" },
      { name: "단가" },
      { name: "공급가액" },
    ],

    rows: [...rawData],
  });

  // // 품목 및 브랜드 테이블 세팅
  for (let rowIdx = startRow + 8; rowIdx < startRow + 31; rowIdx++) {
    // 상품 테이블 칸 정렬 및 글자크기 지정
    columnArr.map((content) => {
      createAllCell(worksheet, content + rowIdx);
    });

    // 상품 테이블 선 지정 (예외 적용)
    createMiddleCell(columnArr, rowIdx, worksheet);
  }
}

// 엑셀 중반 상품 테이블 선 지정 (예외 적용)
export function createMiddleCell(columnArr, rowIdx, worksheet) {
  // 상품 테이블 내 C행일 경우
  // 합쳐진 행처럼 보이기 위해 우측 라인이 필요 없다.
  for (let columnExcept of columnArr) {
    if (columnExcept === "C") {
      worksheet.getCell(columnExcept + rowIdx).border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
      };
      // 상품 테이블 내 D행일 경우
      // 합쳐진 행처럼 보이기 위해  좌측 라인이 필요 없다.
    } else if (columnExcept === "D") {
      worksheet.getCell(columnExcept + rowIdx).border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      // 상품 테이블 내 다른 행일 경우
      // 모든 방향의 라인이 필요하여 하나의 칸으로 보인다.
    } else {
      worksheet.getCell(columnExcept + rowIdx).border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    }
  }
}

// 엑셀 하단(결제 정보)
export async function createEstimateExcelFooter(
  worksheet,
  type,
  data,
  startRow = 32,
  startCol = "A".charCodeAt(0),
  cp_price
) {
  // 결제 정보 결제 상세 설명 및 주의사항
  const contentsArr = [
    // 주문합계, 할인쿠폰, 부가세, 총 주문금액 등
    //할인쿠폰
    ["할인쿠폰", String.fromCharCode(startCol + 3) + startRow],
    //주문합계
    ["주문합계(주문금액)", String.fromCharCode(startCol) + startRow],
    //부가세
    ["부가세", String.fromCharCode(startCol + 3) + (startRow + 1)],
    //총 주문금액
    ["총 주문금액(공급가액)", String.fromCharCode(startCol) + (startRow + 1)],
    //배송비
    ["배송비", String.fromCharCode(startCol + 2) + (startRow + 2)],
    //Reel
    ["Reel", String.fromCharCode(startCol) + (startRow + 2)],
    //포인트
    ["포인트", String.fromCharCode(startCol + 4) + (startRow + 2)],
    //최종결제금액
    ["최종결제금액", String.fromCharCode(startCol) + (startRow + 4)],

    // 하단 주의 사항
    [
      "- 상위 제품의 재고와 가격은 주문/결제 페이지에서 변경될 수 있습니다.",
      String.fromCharCode(startCol) + (startRow + 5),
    ],
    [
      "- 포인트 사용시 최종 결제금액이 변동될 수 있으므로, 포인트 적용 거래명세서를 요청시 별도 제공해드릴수 있습니다.",
      String.fromCharCode(startCol) + (startRow + 6),
    ],
    [
      "- 장바구니 보관 유지기간은 3일입니다.",
      String.fromCharCode(startCol) + (startRow + 7),
    ],
  ];

  // 셀 병합
  const mergeContentsArr = [
    // 경계선
    String.fromCharCode(startCol) +
      (startRow - 1) +
      ":" +
      String.fromCharCode(startCol + 6) +
      (startRow - 1),

    // 총 주문금액
    String.fromCharCode(startCol) +
      startRow +
      ":" +
      String.fromCharCode(startCol + 1) +
      startRow,

    // 할인쿠폰
    String.fromCharCode(startCol + 3) +
      startRow +
      ":" +
      String.fromCharCode(startCol + 4) +
      startRow,
    String.fromCharCode(startCol + 5) +
      startRow +
      ":" +
      String.fromCharCode(startCol + 6) +
      startRow,

    // 주문합계
    String.fromCharCode(startCol) +
      (startRow + 1) +
      ":" +
      String.fromCharCode(startCol + 1) +
      (startRow + 1),

    // 부가세
    String.fromCharCode(startCol + 3) +
      (startRow + 1) +
      ":" +
      String.fromCharCode(startCol + 4) +
      (startRow + 1),
    String.fromCharCode(startCol + 5) +
      (startRow + 1) +
      ":" +
      String.fromCharCode(startCol + 6) +
      (startRow + 1),

    // Reel
    String.fromCharCode(startCol) +
      (startRow + 2) +
      ":" +
      String.fromCharCode(startCol + 1) +
      (startRow + 2),
    // 배송비
    String.fromCharCode(startCol + 2) +
      (startRow + 2) +
      ":" +
      String.fromCharCode(startCol + 3) +
      (startRow + 2),
    // 포인트
    String.fromCharCode(startCol + 4) +
      (startRow + 2) +
      ":" +
      String.fromCharCode(startCol + 6) +
      (startRow + 2),

    // 배송비, reel, 포인트 값
    String.fromCharCode(startCol) +
      (startRow + 3) +
      ":" +
      String.fromCharCode(startCol + 1) +
      (startRow + 3),
    String.fromCharCode(startCol + 2) +
      (startRow + 3) +
      ":" +
      String.fromCharCode(startCol + 3) +
      (startRow + 3),
    String.fromCharCode(startCol + 4) +
      (startRow + 3) +
      ":" +
      String.fromCharCode(startCol + 6) +
      (startRow + 3),

    //최종결제금액
    String.fromCharCode(startCol) +
      (startRow + 4) +
      ":" +
      String.fromCharCode(startCol + 2) +
      (startRow + 4),
    String.fromCharCode(startCol + 3) +
      (startRow + 4) +
      ":" +
      String.fromCharCode(startCol + 6) +
      (startRow + 4),
  ];

  const mergeLastContentArr = [
    // 상위 제품의~
    String.fromCharCode(startCol) +
      (startRow + 5) +
      ":" +
      String.fromCharCode(startCol + 7) +
      (startRow + 5),
    // 포인트 사용시 ~
    String.fromCharCode(startCol) +
      (startRow + 6) +
      ":" +
      String.fromCharCode(startCol + 7) +
      (startRow + 6),
    // 장바구니 보관 ~
    String.fromCharCode(startCol) +
      (startRow + 7) +
      ":" +
      String.fromCharCode(startCol + 7) +
      (startRow + 7),
  ];

  // 주문합계, 할인쿠폰, 공급가액, 부세, 배송비, reel, 포인트, 최종 결제금액
  // PC 엑셀 다운로드
  if (type === "cart") {
    // 주문합계
    // 총 주문금액(공급가액)
    const total_order_price = Number(data.cart_total_price - cp_price);
    const tax = Math.round((data.cart_total_price - cp_price) * 0.1);
    const final_total_price = Number(
      total_order_price + data.reel_fee + data.delivery_fee + tax
    );

    const valueArr = [
      // 주문합계(주문금액)
      [
        "₩" + Number(data.cart_total_price).toLocaleString(),
        String.fromCharCode(startCol + 2) + startRow,
      ],
      // 할인쿠폰
      [
        "₩" + cp_price.toLocaleString(),
        String.fromCharCode(startCol + 5) + startRow,
      ],
      // 총 주문금액(공급가액)
      [
        "₩" + total_order_price.toLocaleString(),
        String.fromCharCode(startCol + 2) + (startRow + 1),
      ],
      // 부가세
      [
        "₩" + tax.toLocaleString(),
        String.fromCharCode(startCol + 5) + (startRow + 1),
      ],
      // 배송비
      [
        "₩" + Number(data.reel_fee).toLocaleString(),
        String.fromCharCode(startCol) + (startRow + 3),
      ],
      // 릴 비용
      [
        "₩" + Number(data.delivery_fee).toLocaleString(),
        String.fromCharCode(startCol + 2) + (startRow + 3),
      ],
      // 포인트
      ["N/A", String.fromCharCode(startCol + 4) + (startRow + 3)],
      // 최종결제금액
      [
        "₩" + final_total_price.toLocaleString(),
        String.fromCharCode(startCol + 3) + (startRow + 4),
      ],
    ];

    valueArr.map((x) => {
      contentsArr.push(x);
    });
    // master 엑셀 다운로드
  } else {
  }
  // 공급자 및 주문자 정보
  createContentAndMerge(
    worksheet,
    contentsArr,
    mergeContentsArr,
    mergeLastContentArr
  );
}

// 장바구니(ct_ids) 및 주문결제(od_id) 데이터 불러오기
export async function getStatementList(type, ids) {
  let username = "N/A";
  let ct_ids = null;
  let od_id = null;
  // PC 엑셀 다운로드
  if (type === "cart") {
    ct_ids = ids;
    const user = await decodeToken();
    if (user && user.payload.mb_name) {
      username = user.payload.mb_name;
    } else {
      username = "N/A";
    }
    // master 엑셀 다운로드
  } else {
    od_id = ids;
  }

  const token = await GetCookie("token");
  // PC 엑셀 데이터
  if (ct_ids) {
    const res = await axios.get(
      process.env.PANDA_API_URL + `/api/cart?type=id&ct_ids=${ct_ids}`,
      {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ` + token,
        },
      }
    );
    if (res.data.status === 200) {
      return { data: res.data.data, username: username };
    }
    // master 엑셀 데이터
  } else {
    const res = await axios.get(
      process.env.MASTER_URL + `/api/v2/order/${od_id}`,
      {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ` + token,
        },
      }
    );
    return { data: res.data.data, username: username };
  }
}

// 엑셀 다운로드
export async function downloadExcel(workbook) {
  // 엑셀 다운로드
  workbook.xlsx
    .writeBuffer()
    .then((data) => {
      let blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let anchor = document.createElement("a");
      let url = URL.createObjectURL(blob);
      anchor.href = url;
      anchor.download = "PandaParts" + ".xlsx";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      URL.revokeObjectURL(url);
    })
    .catch((err) => console.log(err));
}

// 엑셀에 맞는 형태로 데이터로 가공 함수
export function makeExcelRawData(type, arr, cnt) {
  let rawData = [];
  cnt = cnt + 1;
  for (let row of arr) {
    let elArr = [];
    // PC
    if (type === "cart") {
      elArr.push(cnt);
      elArr.push(row["it_name"]);
      elArr.push(row["it_brand"]);
      elArr.push(" ");
      // master
    } else {
      elArr.push(cnt);
      elArr.push(row["it_name"]);
      elArr.push(row["it_brand"]);
      elArr.push(row["it_maker"]);
    }
    elArr.push(Number(row["ct_qty"]).toLocaleString());
    elArr.push(`₩ ${Number(row["ct_unit_price"]).toLocaleString()}`);
    elArr.push(`₩ ${Number(row["ct_price"]).toLocaleString()}`);
    rawData.push(elArr);
    cnt++;
  }
  return rawData;
}
